import { Box } from "@mui/material";
import React from "react";
import { CircularLoading } from "../CircularLoading";

interface ILocalLoadingProps {
    size?: "sm" | "lg";
}

export const LocalLoading = (props: ILocalLoadingProps) => {
    return (
        <Box
            sx={{
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
            }}
        >
            <CircularLoading {...props} />
        </Box>
    );
};
